<template>
  <div id="planMock">
    <ots-main-title></ots-main-title>

    <ots-table-group-new
      v-loading="loading"
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :pagination="pagination"
      @search="search"
    ></ots-table-group-new>

    <!-- 设置模考弹窗 -->
    <ots-custom-dialog :dialog.sync="dialogVisible" :title="dialogTitle" width="1050px">
      <template v-slot:content>
        <el-form ref="mockForm" class="plan-mock-form" :model="mockForm" :rules="rules" label-width="120px" size="small">
          <el-form-item label="考试课程">
            <span>{{ currentRow.courseName }}</span>
          </el-form-item>
          <el-form-item label="模考名称" prop="mockName">
            <el-input v-model="mockForm.mockName" placeholder="请设置模考名称" maxlength="50" show-word-limit style="width: 360px" />
          </el-form-item>
          <el-form-item label="模考起止时间" prop="timeRange">
            <el-date-picker
              v-model="mockForm.timeRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 460px"
            />
          </el-form-item>
          <el-form-item prop="examTime">
            <span slot="label">答卷时长
              <el-tooltip content="0是不限，最大是999" placement="top" effect="dark">
                <i class="el-icon-info" style="color:#909399;cursor:help;margin-left:4px;"></i>
              </el-tooltip>
            </span>
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-input-number v-model="mockForm.examTime" :min="0" :max="999" controls-position="right" class="narrow-input-number" />
              <span>分钟</span>
            </div>
          </el-form-item>
          <el-form-item prop="answerTime">
            <span slot="label">作答次数
              <el-tooltip content="0是不限，最大是99" placement="top" effect="dark">
                <i class="el-icon-info" style="color:#909399;cursor:help;margin-left:4px;"></i>
              </el-tooltip>
            </span>
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-input-number v-model="mockForm.answerTime" :min="0" :max="99" controls-position="right" class="narrow-input-number" />
              <span>次</span>
            </div>
          </el-form-item>
          <el-form-item label="答卷方式" prop="answerWay">
            <el-radio-group v-model="mockForm.answerWay">
              <el-radio :label="0">网页</el-radio>
              <el-radio :label="1">客户端</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="模考试卷" prop="selectedPapers">
            <div style="margin-bottom: 8px">
              <el-input v-model="paperSearchKey" placeholder="按试卷名称筛选" size="small" clearable style="width: 260px" @keyup.enter.native="filterPapers" />
              <el-button type="primary" size="mini" @click="filterPapers">筛选</el-button>
              <el-button size="mini" @click="resetPaperFilter">重置</el-button>
              <span style="margin-left: 8px; color: #909399;">已选 {{ mockForm.selectedPapers.length }} 张</span>
            </div>
            <el-table
              ref="paperTable"
              :data="filteredPaperTableData"
              v-loading="paperLoading"
              border
              size="mini"
              row-key="id"
              max-height="360"
              @selection-change="onPaperSelectionChange"
            >
              <el-table-column type="selection" reserve-selection width="50" align="center" />
              <el-table-column label="试卷名称" prop="name" min-width="220" show-overflow-tooltip />
              <el-table-column label="难度" prop="difficultyDegree" width="100" />
              <el-table-column label="创建日期" prop="createTime" width="140" />
              <el-table-column label="使用次数" prop="usedCount" width="100" align="center" />
              <el-table-column label="总分" prop="score" width="100" align="center" />
            </el-table>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button round @click="dialogVisible = false">取消</el-button>
        <el-button round type="primary" :loading="submitting" @click="submitMock">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>


<script>
import {
  planMockGetCourselistApi,
  planMockSaveMockApi,
  planMockDeleteMockApi,
  queryPaperByCourseCodeApi,
  getPlanListApi
} from "@/http/modules/applySet/planMock.js";

const defaultForm = () => ({
  mockName: "",
  examTime: 60,
  answerTime: 1,
  answerWay: 1,
  timeRange: [],
  selectedPapers: []
});

export default {
  name: "PlanMock",
  data() {
    return {
      loading: false,
      requestForm: {
        planId: "",
        courseId: "",
        setStatus: ""
      },
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: []
        },
        {
          title: "考试课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [{ courseName: "全部", courseId: "" }]
        },
        {
          title: "设置状态",
          type: "select",
          requestKey: "setStatus",
          label: "name",
          value: "value",
          data: [
            { name: "全部", value: "" },
            { name: "已设置", value: "1" },
            { name: "未设置", value: "0" }
          ]
        }
      ],
      tableHeader: [
        { title: "考试批次", prop: "planName", width: 200 },
        { title: "考试课程", prop: "courseName", width: 200 },
        {
          title: "模考名称",
          prop: "mockName",
          width: 200,
          formatter: scope => scope.row.mockName || "-"
        },
        {
          title: "模考试卷名称",
          prop: "paperName",
          width: 260,
          formatter: scope => scope.row.paperName || "-"
        },
        {
          title: "答卷时长",
          prop: "examTime",
          width: 100,
          formatter: scope => {
            if (!scope.row.mockName) return "-";
            if (Number(scope.row.examTime) === 0) return "不限";
            return `${scope.row.examTime} 分钟`;
          }
        },
        {
          title: "作答次数",
          prop: "answerTime",
          width: 100,
          formatter: scope => {
            if (!scope.row.mockName) return "-";
            if (Number(scope.row.answerTime) === 0) return "不限";
            return `${scope.row.answerTime} 次`;
          }
        },
        {
          title: "答卷方式",
          prop: "answerWay",
          width: 100,
          formatter: scope => {
            if (!scope.row.mockName) return "-";
            return Number(scope.row.answerWay) === 0 ? "网页" : "客户端";
          }
        },
        {
          title: "模考起止时间",
          width: 220,
          formatter: scope => {
            if (!scope.row.beginTime) return "-";
            return `${this.formatTime(scope.row.beginTime)} <br>~<br> ${this.formatTime(scope.row.endTime)}`;
          }
        },
        {
          title: "操作",
          type: "buttons",
          width: 200,
          btnList: [
            {
              title: "设置模考",
              click: this.handleSet,
              formatter: scope => !!scope.row.arrangementId || this.isPlanStopped(scope.row)
            },
            {
              title: "编辑",
              click: this.handleEdit,
              formatter: scope => !scope.row.arrangementId || this.isPlanStopped(scope.row)
            },
            {
              title: "删除",
              click: this.handleDelete,
              formatter: scope => !scope.row.arrangementId || this.isPlanStopped(scope.row)
            }
          ]
        }
      ],
      tableOption: {},
      tableData: [],
      pagination: { total: 0 },

      // 设置模考弹窗
      dialogVisible: false,
      submitting: false,
      currentRow: {},
      mockForm: defaultForm(),
      rules: {
        mockName: [{ required: true, message: "请设置模考名称", trigger: "blur" }],
        examTime: [{ required: true, type: "number", message: "请设置答卷时长", trigger: "blur" }],
        answerTime: [{ required: true, type: "number", message: "请设置作答次数", trigger: "blur" }],
        timeRange: [{ required: true, message: "请设置模考起止时间", trigger: "change" }],
        selectedPapers: [{ required: true, type: "array", min: 1, message: "请勾选模考试卷", trigger: "change" }]
      },

      // 试卷列表（设置模考弹窗内联展示）
      paperLoading: false,
      paperTableData: [],
      filteredPaperTableData: [],
      paperSearchKey: "",
      isRestoringSelection: false
    };
  },
  computed: {
    dialogTitle() {
      return this.currentRow.arrangementId ? "编辑模考设置" : "设置模考";
    }
  },
  watch: {
    "requestForm.planId"() {
      this.onPlanChange();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      try {
        const { data } = await getPlanListApi();
        this.selectList[0].data = data || [];
        if (this.selectList[0].data.length > 0) {
          this.requestForm.planId = this.selectList[0].data[0].id;
        }
      } catch (e) {
        console.error("init planMock error:", e);
      }
    },
    async onPlanChange() {
      if (!this.requestForm.planId) return;
      this.requestForm.courseId = "";
      this.requestForm.setStatus = "";
      await this.loadCourseAndTable();
    },
    async loadCourseAndTable() {
      this.loading = true;
      try {
        const { data } = await planMockGetCourselistApi({
          planId: this.requestForm.planId,
          courseId: "",
          setStatus: ""
        });
        this.tableData = data || [];
        this.pagination.total = this.tableData.length;
        this.selectList[1].data = [
          { courseName: "全部", courseId: "" },
          ...this.extractCourses(this.tableData)
        ];
      } finally {
        this.loading = false;
      }
    },
    async search() {
      if (!this.requestForm.planId) {
        this.$message.warning("请先选择考试批次");
        return;
      }
      this.loading = true;
      try {
        const { planId, courseId, setStatus } = this.requestForm;
        const { data } = await planMockGetCourselistApi({ planId, courseId, setStatus });
        this.tableData = data || [];
        this.pagination.total = this.tableData.length;
      } finally {
        this.loading = false;
      }
    },
    extractCourses(list) {
      const map = new Map();
      list.forEach(item => {
        if (item.courseId && !map.has(item.courseId)) {
          map.set(item.courseId, { courseId: item.courseId, courseName: item.courseName });
        }
      });
      return Array.from(map.values());
    },
    handleSet(row) {
      this.currentRow = { ...row };
      this.mockForm = defaultForm();
      this.dialogVisible = true;
      this.$nextTick(() => this.loadPapers());
    },
    handleEdit(row) {
      this.currentRow = { ...row };
      // 与列表 formatter 对齐：用 Number() 归一化，null/""/undefined/NaN 一律按 0（不限）处理
      const examTime = Number(row.examTime);
      const answerTime = Number(row.answerTime);
      const answerWay = Number(row.answerWay);
      this.mockForm = {
        mockName: row.mockName || "",
        examTime: isNaN(examTime) ? 0 : examTime,
        answerTime: isNaN(answerTime) ? 0 : answerTime,
        answerWay: isNaN(answerWay) ? 1 : answerWay,
        timeRange: row.beginTime && row.endTime ? [this.formatTime(row.beginTime), this.formatTime(row.endTime)] : [],
        selectedPapers: this.parsePapers(row.paperId, row.paperName)
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.loadPapers());
    },
    parsePapers(paperIdStr, paperNameStr) {
      if (!paperIdStr) return [];
      const ids = String(paperIdStr).split(",").filter(Boolean);
      const names = String(paperNameStr || "").split(",");
      return ids.map((id, idx) => ({ id, name: names[idx] || "" }));
    },
    async loadPapers() {
      this.paperLoading = true;
      this.isRestoringSelection = true;
      try {
        const { data } = await queryPaperByCourseCodeApi({
          planId: this.requestForm.planId,
          courseId: this.currentRow.courseId,
          page: 1,
          size: 100
        });
        this.paperTableData = (data && data.papers) || [];
        this.filteredPaperTableData = [...this.paperTableData];
        this.paperSearchKey = "";
        // 清空旧勾选并恢复已选试卷的勾选状态（编辑模式）
        await this.$nextTick();
        if (this.$refs.paperTable) {
          this.$refs.paperTable.clearSelection();
          this.mockForm.selectedPapers.forEach(p => {
            const row = this.paperTableData.find(x => x.id === p.id);
            if (row) this.$refs.paperTable.toggleRowSelection(row, true);
          });
        }
        await this.$nextTick();
      } finally {
        this.isRestoringSelection = false;
        this.paperLoading = false;
      }
    },
    filterPapers() {
      const key = this.paperSearchKey.trim().toLowerCase();
      if (!key) {
        this.filteredPaperTableData = [...this.paperTableData];
        return;
      }
      this.filteredPaperTableData = this.paperTableData.filter(p =>
        (p.name || "").toLowerCase().includes(key)
      );
    },
    resetPaperFilter() {
      this.paperSearchKey = "";
      this.filteredPaperTableData = [...this.paperTableData];
    },
    onPaperSelectionChange(selection) {
      if (this.isRestoringSelection) return;
      this.mockForm.selectedPapers = selection.map(p => ({ id: p.id, name: p.name }));
      if (this.$refs.mockForm) this.$refs.mockForm.validateField("selectedPapers");
    },
    submitMock() {
      this.$refs.mockForm.validate(async valid => {
        if (!valid) return;
        const { planId } = this.requestForm;
        const { courseId } = this.currentRow;
        const params = {
          planId,
          courseId,
          mockName: this.mockForm.mockName.trim(),
          beginTime: this.mockForm.timeRange[0],
          endTime: this.mockForm.timeRange[1],
          examTime: this.mockForm.examTime,
          answerTime: this.mockForm.answerTime,
          answerWay: this.mockForm.answerWay,
          paperId: this.mockForm.selectedPapers.map(p => p.id).join(","),
          paperName: this.mockForm.selectedPapers.map(p => p.name).join(",")
        };
        this.submitting = true;
        try {
          const { code, msg, error } = await planMockSaveMockApi(params);
          if (code === 1) {
            this.$message.success(this.currentRow.arrangementId ? "编辑成功" : "设置成功");
            this.dialogVisible = false;
            await this.loadCourseAndTable();
          } else {
            this.$message.error(msg || error || "保存失败");
          }
        } finally {
          this.submitting = false;
        }
      });
    },
    handleDelete(row) {
      this.$confirm(`确认删除「${row.courseName}」的模考设置吗？`, "提示", {
        type: "warning"
      })
        .then(async () => {
          const { code, msg, error } = await planMockDeleteMockApi({
            planId: row.planId,
            courseId: row.courseId
          });
          if (code === 1) {
            this.$message.success("删除成功");
            await this.loadCourseAndTable();
          } else {
            this.$message.error(msg || error || "删除失败");
          }
        })
        .catch(() => {});
    },
    formatTime(t) {
      if (!t) return "";
      if (Array.isArray(t)) {
        const [y, M, d, h = 0, m = 0, s = 0] = t;
        return `${y}-${String(M).padStart(2, "0")}-${String(d).padStart(2, "0")} ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
      }
      return String(t).replace("T", " ");
    },
    isPlanStopped(row) {
      if (!row.planEndExam) return false;
      const str = this.formatTime(row.planEndExam);
      const d = new Date(str.replace(/-/g, "/"));
      return new Date() >= d;
    }
  }
};
</script>


<style scoped lang="less">
#planMock {
  padding: 0 20px;
}
.text-danger {
  color: #f56c6c;
}
/deep/ .otstablenew .operate .el-button.is-disabled {
  display: none;
}
</style>

<!-- 弹窗 append-to-body 到 body 下，scoped 样式选不到，必须用全局样式覆盖 ots-custom-dialog 的 label 上下堆叠 -->
<style>
.el-dialog .plan-mock-form .el-form-item {
  display: flex;
  align-items: flex-start;
}
.el-dialog .plan-mock-form .el-form-item__label {
  flex-shrink: 0;
  text-align: right;
  padding-bottom: 0 !important;
  line-height: 36px;
}
.el-dialog .plan-mock-form .el-form-item__content {
  flex: 1;
  line-height: 36px;
  margin-left: 20px !important;
}

.el-dialog .plan-mock-form .narrow-input-number {
  width: 240px;
}
.el-dialog .plan-mock-form .narrow-input-number .el-input__inner {
  padding-left: 32px;
  padding-right: 32px;
  text-align: center;
}
</style>
